import { useCallback, useEffect, useState } from 'react'
import { useTonWallet } from '@tonconnect/ui-react'
import { api } from '../lib/api'
import { chatStorage } from '../lib/chat-storage'

const STORAGE_KEY = (addr: string) => `imago:key:${addr}`

export function useAuth() {
  const wallet = useTonWallet()
  const [apiKey, setApiKey] = useState<string | null>(null)

  useEffect(() => {
    if (!wallet) {
      setApiKey(null)
      api.setKey('')
      // Switch to guest storage when wallet disconnects
      chatStorage.setWallet(null)
      return
    }

    const address = wallet.account.address
    // Switch chat storage to this wallet's namespace
    chatStorage.setWallet(address)

    const cached = localStorage.getItem(STORAGE_KEY(address))

    if (cached) {
      api.setKey(cached)
      setApiKey(cached)
      return
    }

    // First-time login — auto-create/fetch the default key for this wallet
    api.walletLogin(address).then((key) => {
      localStorage.setItem(STORAGE_KEY(address), key)
      api.setKey(key)
      setApiKey(key)
    }).catch(() => {
      // silently ignore — user can retry by reconnecting wallet
    })
  }, [wallet?.account.address])

  /** Called after the user creates their first (or replacement) key. */
  const setFirstKey = useCallback((address: string, key: string) => {
    localStorage.setItem(STORAGE_KEY(address), key)
    api.setKey(key)
    setApiKey(key)
  }, [])

  return { apiKey, setFirstKey }
}
